// Данная функция нужна для определения строк которые будут использоваться как классы в tailwind
// Наименование этой функции необходимо указать в конфиге prettier:
// "tailwindFunctions": ["tw"] // для сортировки классов prettier-plugin-tailwindcss
// "customFunctions": ["tw"] // для переноса длинной строки классов prettier-plugin-classnames
// и в настройках vscode:
// "tailwindCSS.classFunctions": ["tw"] // для подсвечивания классов расширением Tailwind CSS IntelliSense

export const tw = (string: string) => string;
